import { ReactNode } from 'react';
import { MAIN_PACE_TASK_IDs } from '@symfa-inc/providence-verizon-types';
import { ColumnsType } from 'antd/lib/table/interface';
import {
  getJurisdictionByIdOrUndefined,
  projectFuzeIDRender,
  projectPaceTaskDataRender,
  providenceAgentRender,
  readOnlyInputNumberRender,
} from '@core/utils/methods';
import { IdAndValue, SiteBrowse } from '@models/interfaces';
import { Browse } from '@models/types';

export const ENGINEERING_BROWSE_COLUMNS: ColumnsType<Browse> = [
  {
    title: 'A/E CD Vendor',
    dataIndex: 'scoping',
    key: 'AEVendor',
    width: 160,
    render: ({ AEVendor }: { AEVendor: IdAndValue }): ReactNode =>
      AEVendor?.value,
  },
  {
    title: 'A/E Mount Vendor',
    dataIndex: 'scoping',
    key: 'AEMountVendor',
    width: 180,
    sorter: true,
    render: ({ AEMountVendor }: { AEMountVendor: IdAndValue }): ReactNode =>
      AEMountVendor?.value,
  },
  {
    title: 'Alternate Site Info',
    width: 170,
    key: 'alternateSiteInfo',
    sorter: true,
    dataIndex: 'site',
    render: (site: SiteBrowse): ReactNode => site.alternateSiteInfo,
  },
  {
    title: 'Civil Vendor',
    dataIndex: 'civilVendor',
    key: 'civilVendor',
    width: 140,
    sorter: true,
    render: (civilVendor: IdAndValue): ReactNode => civilVendor?.value,
  },
  {
    title: 'PS Location Code',
    dataIndex: 'site',
    key: 'PSLocationCode',
    width: 140,
    sorter: true,
    render: (site: SiteBrowse): ReactNode =>
      readOnlyInputNumberRender(site?.PSLocationCode),
  },
  {
    title: 'Jurisdiction',
    dataIndex: 'site',
    key: 'jurisdiction',
    width: 180,
    sorter: true,
    render: (site: SiteBrowse): ReactNode =>
      getJurisdictionByIdOrUndefined(site?.jurisdiction?.id)?.jurisdictionName,
  },
  {
    title: 'Contract Number',
    width: 150,
    key: 'contractNumber',
    sorter: true,
    dataIndex: 'site',
    render: (site: SiteBrowse): ReactNode => site.contractNumber,
  },
  {
    title: 'PS Project Number',
    dataIndex: 'fuzeIDs',
    key: 'PSProjectNumber',
    width: 150,
    sorter: true,
    render: projectFuzeIDRender({
      field: 'PSProjectNumber',
    }),
  },
  {
    title: 'Fuze ID',
    dataIndex: 'fuzeIDs',
    key: 'fuzeId',
    width: 150,
    sorter: true,
    render: projectFuzeIDRender({
      field: 'fuzeID',
    }),
  },
  {
    title: 'Project Type',
    dataIndex: 'projectType',
    key: 'projectType',
    width: 140,
    render: (projectType: IdAndValue): ReactNode => projectType?.value,
  },
  {
    title: 'Providence Agent',
    key: 'providenceAgent',
    width: 180,
    sorter: true,
    dataIndex: 'providenceAgent',
    render: providenceAgentRender,
  },
  {
    title: 'SOF Issued Date',
    dataIndex: 'projectPaceTaskData',
    key: 'SOFIssued',
    width: 160,
    render: projectPaceTaskDataRender({
      id: MAIN_PACE_TASK_IDs.SOFIssued,
      field: 'actualDate',
    }),
  },
  {
    title: 'SS014 Scoping Complete',
    dataIndex: 'projectPaceTaskData',
    key: 'SS014ScopingComplete',
    width: 225,
    render: projectPaceTaskDataRender({
      id: MAIN_PACE_TASK_IDs.scopingComplete,
      field: 'actualDate',
    }),
  },
  {
    title: 'Site Name',
    dataIndex: 'siteName',
    key: 'siteName',
    width: 100,
    sorter: true,
    render: (site: SiteBrowse): ReactNode => site?.siteName,
  },
  {
    title: 'State',
    dataIndex: 'site',
    key: 'state',
    width: 120,
    sorter: true,
    render: (site: SiteBrowse): ReactNode => site?.state?.name,
  },
  {
    title: 'Submarket',
    key: 'submarket',
    width: 140,
    sorter: true,
    dataIndex: 'site',
    render: (site: SiteBrowse): ReactNode => site.submarket?.value,
  },
  {
    title: 'Tower Owner',
    dataIndex: 'site',
    key: 'towerOwner',
    width: 150,
    sorter: true,
    render: (site: SiteBrowse): ReactNode => site?.towerOwner?.value,
  },
  {
    title: 'MDG Location Code',
    key: 'MDGLocationCode',
    dataIndex: 'site',
    width: 180,
    render: (site: SiteBrowse): ReactNode => site?.MDGLocationCode,
  },
];
